var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.75C22.1989 6.75 22.3897 6.67098 22.5303 6.53033C22.671 6.38968 22.75 6.19891 22.75 6C22.75 5.80109 22.671 5.61032 22.5303 5.46967C22.3897 5.32902 22.1989 5.25 22 5.25V6.75ZM14 5.25C13.8011 5.25 13.6103 5.32902 13.4697 5.46967C13.329 5.61032 13.25 5.80109 13.25 6C13.25 6.19891 13.329 6.38968 13.4697 6.53033C13.6103 6.67098 13.8011 6.75 14 6.75V5.25ZM18.75 2C18.75 1.80109 18.671 1.61032 18.5303 1.46967C18.3897 1.32902 18.1989 1.25 18 1.25C17.8011 1.25 17.6103 1.32902 17.4697 1.46967C17.329 1.61032 17.25 1.80109 17.25 2H18.75ZM17.25 10C17.25 10.1989 17.329 10.3897 17.4697 10.5303C17.6103 10.671 17.8011 10.75 18 10.75C18.1989 10.75 18.3897 10.671 18.5303 10.5303C18.671 10.3897 18.75 10.1989 18.75 10H17.25ZM22 5.25H18V6.75H22V5.25ZM18 5.25H14V6.75H18V5.25ZM17.25 2V6H18.75V2H17.25ZM17.25 6V10H18.75V6H17.25Z",
    fill: "#808D9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3C7.022 3 4.782 3 3.391 4.391C2 5.782 2 8.021 2 12.5C2 16.978 2 19.218 3.391 20.609C4.782 22 7.021 22 11.5 22C15.978 22 18.218 22 19.609 20.609C21 19.218 21 16.979 21 12.5V12",
    stroke: "#808D9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1352C2.62 14.0452 3.244 14.0012 3.872 14.0032C6.524 13.9472 9.111 14.7732 11.172 16.3342C13.082 17.7822 14.425 19.7742 15 22.0002",
    stroke: "#808D9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.8961C19.825 16.3011 18.609 15.9991 17.386 16.0001C15.535 15.9931 13.702 16.6731 12 18.0001",
    stroke: "#808D9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputImgIcon);
export default __webpack_public_path__ + "static/media/input-img-icon.13f1b4318d769902649a22ead642d42a.svg";
export { ForwardRef as ReactComponent };